import { z } from 'zod';
// Project schema matching the backend ProjectModel
export const projectSchema = z.object({
    id: z.string(),
    userId: z.string(),
    name: z.string(),
    lifeDomains: z.array(z.string()),
    labels: z.array(z.string()),
    color: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
// Form data for creating/updating projects
export const projectCreateSchema = z.object({
    name: z.string().min(1, 'Project name is required'),
    lifeDomains: z.array(z.string()).default([]),
    labels: z.array(z.string()).default([]),
    color: z.string().default('#000000'),
});
